import {api} from '../api'

export const endpointApi = api.injectEndpoints({
  endpoints: (build) => ({
    fetchEndpoint: build.query({
      query(payload) {
        return {
          url: `/endpoint/`,
          method: 'GET',
          params: {
            status: payload?.status,
            ordering: payload?.ordering,
            // Без merchant_id придут точки всех мерчантов пользователя, а у
            // владельца платформы — ещё и точки заказчиков.
            merchant_id: payload?.merchant_id,
            ...(payload?.text?.length > 0 ? {name__icontains: payload?.text} : [])
          }
        }
      },
    }),

    createEndpoint: build.query({
      query(payload) {
        return {
          url: `/endpoint/`,
          method: 'POST',
          data: payload
        }
      },
    }),


    fetchEndpointId: build.query({
      query(payload) {
        return {
          url: `/endpoint/${payload.id}/`,
          method: 'GET',
        }
      },
    }),


    updateEndpointId: build.query({
      query(payload) {
        return {
          url: `/endpoint/${payload.id}/`,
          method: 'PUT',
          data: payload.data
        }
      },
    }),

    endpointAddEmployees: build.query({
      query(payload) {
        return {
          url: `/endpoint/${payload.id}/add_employees/`,
          method: 'POST',
          data: payload.employees
        }
      },
    }),
    endpointRemoveEmployees: build.query({
      query(payload) {
        return {
          url: `/endpoint/${payload.id}/remove_employees/`,
          method: 'POST',
          data: payload.employees
        }
      },
    }),

    // Лимит точки: upsert активного лимита. Сам лимит и остаток за сегодня
    // приходят полем limit в /endpoint/ и /endpoint/{id}/.
    upsertEndpointLimit: build.query({
      query(payload) {
        return {
          url: `/endpoint-limit/`,
          method: 'POST',
          data: payload
        }
      },
    }),

    deleteEndpointLimit: build.query({
      query(payload) {
        return {
          url: `/endpoint-limit/${payload.id}/`,
          method: 'DELETE',
        }
      },
    }),

    // Активный лимит точки; поле today — использовано и остаток за сегодня,
    // в том же виде, что поле limit в /endpoint/{id}/. Нет лимита — пустой список.
    fetchEndpointLimits: build.query({
      query(params) {
        return {
          url: `/endpoint-limit/`,
          method: 'GET',
          params,
        }
      },
    }),
  }),
})
